// extracted by mini-css-extract-plugin
export default {"auctioneer-property-info":"adc__auctioneer-property-info--MAZ9s"};